"use strict";
const options = {
  blogLoadMore: ".collections-load-more",
  btnSharing: ".blog-sharing .btn-sharing",
};

var BlsEventBlogShopify = (function () {
  return {
    init: function () {
      this.eventLoadMore();
      this.eventShareBlogPost();
      const _this = this;
      document.addEventListener("DOMContentLoaded", function () {
        var tables = document.querySelectorAll("table");
        tables.forEach(function (table) {
          var wrapper = document.createElement("div");
          wrapper.className = "scrollable-container";
          table.parentNode.insertBefore(wrapper, table);
          wrapper.appendChild(table);
        });
        var href = document.querySelectorAll(".article-template__content a");
        var tag = document.querySelectorAll(".blog-meta-tag a");
        if (href || tag) {
          href.forEach((attr) => {
            attr.setAttribute("target", "_blank");
          });
          tag.forEach((attr) => {
            attr.setAttribute("target", "_blank");
          });
        }
        _this.tableOfContent();
      });
    },

    eventShareBlogPost: function () {
      document.querySelectorAll(options.btnSharing).forEach((share) => {
        share.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            const social = target.getAttribute("data-social");
            window.open(social);
          },
          false
        );
      });
    },

    eventLoadMore: function () {
      document.querySelectorAll(options.blogLoadMore).forEach((loadMore) => {
        var _this = this;
        if (loadMore.classList.contains("infinit-scrolling")) {
          var observer = new IntersectionObserver(
            function (entries) {
              entries.forEach((entry) => {
                entries.forEach((entry) => {
                  if (entry.intersectionRatio === 1) {
                    _this.loadMoreProducts(loadMore);
                  }
                });
              });
            },
            { threshold: 1.0 }
          );
          observer.observe(loadMore);
        } else {
          loadMore.addEventListener(
            "click",
            (event) => {
              event.preventDefault();
              const target = event.currentTarget;
              _this.loadMoreProducts(target);
            },
            false
          );
        }
      });
    },

    loadMoreProducts: function (target) {
      const loadMore_url = target.getAttribute("href");
      this.toggleLoading(target, true);
      fetch(`${loadMore_url}`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((responseText) => {
          const productNodes = parser.parseFromString(
            responseText,
            "text/html"
          );
          const productNodesHtml = productNodes.querySelectorAll(
            "#bls__blog-container .bls__blog-posts-item"
          );
          productNodesHtml.forEach((prodNode) =>
            document.getElementById("bls__blog-articles").appendChild(prodNode)
          );
          const load_more = productNodes.querySelector(
            ".collections-load-more"
          );
          document.querySelector(".load-more-amount").innerHTML =
            productNodes.querySelector(".load-more-amount").textContent;
          document.querySelector(".load-more-percent").style.width =
            productNodes.querySelector(".load-more-percent").style.width;
          if (load_more) {
            target.setAttribute("href", load_more.getAttribute("href"));
          } else {
            target.remove();
          }
          this.toggleLoading(target, false);
          BlsLazyloadImg.init();
        })
        .catch((error) => {
          throw error;
        });
    },

    toggleLoading: function (event, loading) {
      if (event) {
        const method = loading ? "add" : "remove";
        event.classList[method]("loading");
      }
    },

tableOfContent: function () {
  const content = document.querySelector(".article-template__content");
  const headers = content?.querySelectorAll("h2, h3");
  const tocMobile = document.querySelector(".toc-mobile")?.querySelector("ol");
  const tocDesktop = document.querySelector(".toc-desktop")?.querySelector("ol");

  function buildTOC(tocContainer) {
    let lastH2Item = null;
    let subUl = null;

    headers?.forEach((header, index) => {
      const text = header.textContent.trim();
      const id = `section-${index}-${text
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^\w-]+/g, "")}`;
      header.id = id;

      const anchor = document.createElement("a");
      anchor.href = `#${id}`;
      anchor.textContent = text;
      const listItem = document.createElement("li");

      if (header.tagName.toLowerCase() === "h2" && text.length > 0) {
        listItem.appendChild(anchor);
        tocContainer?.appendChild(listItem);
        lastH2Item = listItem;
        subUl = null;
      } else if (header.tagName.toLowerCase() === "h3" && lastH2Item) {
        if (!subUl) {
          subUl = document.createElement("ul");
          subUl.classList.add("dropdown-content", "sub-toc", "list-none");
          lastH2Item.appendChild(subUl);
          lastH2Item.classList.add("has-dropdown");
          const h2Anchor = lastH2Item.querySelector("a");
          h2Anchor.classList.add("dropdown");
          h2Anchor.addEventListener("click", function (event) {
            event.preventDefault();
            subUl.classList.toggle("active");
          });
        }
        const subListItem = document.createElement("li");
        subListItem.appendChild(anchor);
        subUl.appendChild(subListItem);
      }
    });
  }

  buildTOC(tocMobile);
  buildTOC(tocDesktop);

  const tocMobileContainer = document.querySelector(".toc-mobile");
  const tocMobileOl = tocMobileContainer?.querySelector("ol");
  const tocDesktopContainer = document.querySelector(".toc-desktop");
  const tocDesktopOl = tocDesktopContainer?.querySelector("ol");

  const updateStickyTop = () => {
    const header =
      document.querySelector(".page-header") ||
      document.querySelector(".header") ||
      document.querySelector(".navbar");
    const top = (header ? header.offsetHeight : 0) + 16;
    document.documentElement.style.setProperty("--toc-sticky-top", `${top}px`);
  };

  if (tocMobileContainer) {
    const hasMobile = tocMobileOl && tocMobileOl.children.length > 0;
    if (!hasMobile) tocMobileContainer.style.display = "none";
    else if (window.matchMedia("(max-width: 767px)").matches) tocMobileContainer.style.display = "block";
  }

  if (tocDesktopContainer) {
    const hasDesktop = tocDesktopOl && tocDesktopOl.children.length > 0;
    if (!hasDesktop) {
      tocDesktopContainer.style.display = "none";
    } else if (window.matchMedia("(min-width: 768px)").matches) {
      tocDesktopContainer.style.display = "block";
      updateStickyTop();
      window.addEventListener("resize", updateStickyTop);
    }
  }

  const tocLinks = document.querySelectorAll(".toc-mobile a, .toc-desktop a");
  tocLinks.forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      const targetId = this.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetId);
      if (!targetElement) return;

 
      const header =
        document.querySelector(".page-header") ||
        document.querySelector(".header") ||
        document.querySelector(".navbar");
      const headerHeight = header ? header.offsetHeight : 0;


      const rect = targetElement.getBoundingClientRect();
      const scrollTop = rect.top + window.scrollY - headerHeight;

      window.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });

      history.pushState(null, null, `#${targetId}`);
    });
  });
},
  };
})();
BlsEventBlogShopify.init();

var BlsEventPostByAuthor = (function() {
  return {
    init: function () {
      if (!document.getElementById('title-posts-by-author')) return;
      this.paginationEvent();
    },
    paginationEvent: function() {
      const pagination = document.getElementById('post-by-author');
      const posts = document.getElementById('title-posts-by-author');
      if (!pagination || !posts) return;

      let currentPage = 1;
      const itemsPerPage = 9;
      const dataPosts = JSON.parse(posts.textContent.trim() || '[]');
      const arrayPost = Array.from(document.querySelectorAll('#bls__blog-articles-author .bls__blog-posts-item'));
      const idScroll = document.getElementById('title-blog-post-author');
      const wrapper = document.querySelector('.section-blog-by-author');
        document.addEventListener("DOMContentLoaded", function () {
          if (dataPosts.length === 0 && wrapper) {
            wrapper.style.display = 'none'
          }
        })
      displayResults(dataPosts)
      function displayResults(results) {
        const start = (currentPage - 1) * itemsPerPage;
        const end = start + itemsPerPage;
        let displayedCount = 0;
        arrayPost.forEach(item => {
          if (results.includes(item.dataset.title)) {
            if (displayedCount >= start && displayedCount < end) {
              item.style.display = 'block';
            } else {
              item.style.display = 'none';
            }
            displayedCount++;
          } else {
            item.style.display = 'none';
          }
          if (results.length > itemsPerPage) {
            pagination.style.display = 'flex';
            displayPagination(displayedCount, pagination);
          } else {
            pagination.style.display = 'none';
          }
        });
      }

      function displayPagination(totalItems, pagination) {
        const totalPages = Math.ceil(totalItems / itemsPerPage);
        pagination.innerHTML = '';
        const prevButton = document.createElement('li');
        const aPrevButton = document.createElement('a');
        aPrevButton.setAttribute('role', 'link');
        aPrevButton.classList.add('pagination__item','pagination__item--next','pagination__item-arrow','link','motion-reduce');
        aPrevButton.textContent = 'Back';
        prevButton.appendChild(aPrevButton)
        if (currentPage === 1) {
          prevButton.classList.add('disabled');
        }
        prevButton.addEventListener('click', function () {
          if (currentPage > 1) {
            currentPage--;
            displayResults(dataPosts);
            idScroll?.scrollIntoView({ behavior: 'smooth' });
          }
        });
        pagination.appendChild(prevButton);

        for (let i = 1; i <= totalPages; i++) {
          const button = document.createElement('li');
          const aButton = document.createElement('a');
          aButton.setAttribute('role', 'link');
          aButton.setAttribute('aria-label', `Page ${currentPage}`)
          aButton.classList.add('pagination__item','link');
          aButton.textContent = i;
          if (i === currentPage) {
            aButton.classList.add('pagination__item--current');
          }
          button.appendChild(aButton);
          button.addEventListener('click', function () {
            currentPage = i;
            displayResults(dataPosts);
            idScroll?.scrollIntoView({ behavior: 'smooth' });
          });
          pagination.appendChild(button);
        }

        const nextButton = document.createElement('li');
        const aNextButton = document.createElement('a');
        aNextButton.setAttribute('role', 'link');
        aNextButton.classList.add('pagination__item','pagination__item--prev','pagination__item-arrow','link','motion-reduce');
        aNextButton.textContent = 'Next';
        nextButton.appendChild(aNextButton);
        if (currentPage === totalPages) {
          nextButton.classList.add('disabled')
        }
        nextButton.addEventListener('click', function () {
          if (currentPage < totalPages) {
            currentPage++;
            displayResults(dataPosts);
            idScroll?.scrollIntoView({ behavior: 'smooth' });
          }
        });
        pagination.appendChild(nextButton);
      }
    }
  }
})();
BlsEventPostByAuthor.init();

function shareLinkedIn() {
  const linkedInURL =
    "https://www.linkedin.com/shareArticle?mini=true&url=" +
    encodeURIComponent(window.location.href);
  window.open(linkedInURL, "sharer", "toolbar=0,status=0,width=660,height=445");
}
